// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_ALzS2","stock_box":"index_stock_box_aXlbk","adBox":"index_adBox_qZst3"};